export default __webpack_public_path__ + "static/media/synapps-typeface.651eae69.svg";